<template>
  <div class="referralBox">
    <!-- 什么是引荐计划？ -->
    <div class="oneBox">
      <div class="titleBox">
        <span class="title">{{ $t('exPand.exTextOne') }}</span>
        <span class="content">{{ $t('exPand.exTextTwo') }}</span>
      </div>
      <div class="imgBox">
        <img
          :class="{
            bgImg: true,
            bgImgEn: lang == 'en',
          }"
          :src="$utils.getPng(icon1)"
          alt=""
        />
      </div>
    </div>
    <!-- 邀请方式 -->
    <div class="twoBox">
      <div class="titleBox">
        <span class="title">{{ $t('exPand.InvitationMethods') }}</span>
        <span class="content">{{ $t('exPand.exTextThree') }}</span>
      </div>
      <div class="contentBox">
        <span class="top">{{ $t('exPand.exTextFour') }}</span>
        <div class="bottom">
          <div class="left">
            <div class="font">{{ invited.feemoo_link }}</div>
          </div>
          <div class="copyBtn" @click="copyBtn(invited.feemoo_link)">
            <svg-btn icon-class="icon-copy" />
            <span style="margin-left: 4px">{{
              $t('exPand.CopyInviteLink')
            }}</span>
          </div>
        </div>
      </div>
      <div class="contentBox">
        <span class="top">{{ $t('exPand.exTextFive') }}</span>
        <div class="bottom">
          <div class="left">
            <div class="font">{{ invited.cm_link }}</div>
          </div>
          <div class="copyBtn" @click="copyBtn(invited.cm_link)">
            <svg-btn icon-class="icon-copy" />
            <span style="margin-left: 4px">{{
              $t('exPand.CopyInviteLink')
            }}</span>
          </div>
        </div>
      </div>
      <img
        v-if="false"
        @click="toDrive"
        class="bgImgTwo"
        :src="$utils.getPng(icon2)"
        alt=""
      />
    </div>
    <!-- 奖励一 -->
    <div class="threeBox">
      <div class="titleBox">
        <span class="leftF">{{ $t('exPand.exTextSix') }}</span>
        <div class="rightF" @click="openRecord(1)">
          {{ $t('exPand.InviteHistory') }}
        </div>
      </div>
      <div class="rewardBox">
        <div class="reward">
          <span class="topFont">{{
            $t('exPand.NumberofInvitedReferrals')
          }}</span>
          <div class="buttomBox">
            <span class="leftFont">{{
              formatNumber(grant_1.invited_count)
            }}</span>
            <span class="rightFont">{{ $t('exPand.users') }}</span>
          </div>
        </div>
        <div class="reward marLeft">
          <div class="twoTitle">
            <span class="topFont">{{ $t('exPand.ValidInvites') }}</span>
            <el-tooltip
              popper-class="markReferral"
              effect="dark"
              placement="bottom"
            >
              <div slot="content">
                <div>{{ $t('exPand.exTextSeven') }}</div>
                <div>{{ $t('exPand.exTextEight') }}</div>
              </div>
              <img
                class="markImg"
                :src="$utils.getPng('referral-three')"
                alt=""
              />
            </el-tooltip>
          </div>
          <div class="buttomBox">
            <span class="leftFont">{{
              formatNumber(grant_1.valid_invited_count)
            }}</span>
            <span class="rightFont">{{ $t('exPand.users') }}</span>
          </div>
        </div>
        <div class="reward marLeft">
          <div class="twoTitle">
            <span class="topFont">{{ $t('exPand.TotalRewards') }}</span>
            <el-tooltip
              popper-class="markReferral"
              effect="dark"
              placement="bottom"
            >
              <div slot="content">
                <div>{{ $t('exPand.exTextNine') }}</div>
                <!-- <div>{{ $t('exPand.exTextTen') }}</div> -->
              </div>
              <img
                class="markImg"
                :src="$utils.getPng('referral-three')"
                alt=""
              />
            </el-tooltip>
          </div>
          <div class="buttomBox">
            <span class="leftFont">{{ formatNumber(grant_1.grant_day) }}</span>
            <span class="rightFont">{{ $t('exPand.Sheet') }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 奖励二 -->
    <div class="threeBox">
      <div class="titleBox">
        <span class="leftF">{{ $t('exPand.exTextEleven') }}</span>
        <div class="rightB">
          <span class="front">{{ $t('exPand.CurrentRewards') }}</span>
          <div class="behind">
            <div
              :class="{
                inside: true,
                insideA: isInside == 0,
              }"
              @click="changeType(0)"
            >
              {{ $t('exPand.Membershipduration') }}
            </div>
            <div
              :class="{
                inside: true,
                insideA: isInside == 1,
              }"
              @click="changeType(1)"
            >
              {{ $t('exPand.ActivationAmount') }}
            </div>
          </div>
        </div>
      </div>
      <div class="lineFont">{{ $t('exPand.Membershipduration') }}：</div>
      <div class="rewardBox">
        <div class="reward">
          <div class="twoTitle">
            <span class="topFont">{{ $t('exPand.PendingRewards') }}</span>
            <el-tooltip
              popper-class="markReferral markReferralOne"
              effect="dark"
              placement="bottom"
            >
              <div slot="content">
                <div>
                  {{ $t('exPand.exTextFiftySix')}}
                </div>
                <!-- <span>{{ $t('exPand.exTextNineteen') }}</span>
                <span>{{ $t('exPand.exTextTwenty') }}</span> -->
              </div>
              <img
                class="markImg"
                :src="$utils.getPng('referral-three')"
                alt=""
              />
            </el-tooltip>
          </div>
          <div class="buttomBox">
            <span class="leftFont">{{
              formatNumber(grant_2.grant_day_pendding)
            }}</span>
            <span class="rightFont">{{ $t('exPand.Days') }}</span>
          </div>
        </div>
        <div class="reward marLeft">
          <span class="topFont">{{ $t('exPand.ReceivedRewards') }}</span>
          <div class="buttomBox">
            <span class="leftFont">{{
              formatNumber(grant_2.grant_day_processed)
            }}</span>
            <span class="rightFont">{{ $t('exPand.Days') }}</span>
          </div>
        </div>
        <div class="reward marLeft">
          <span class="topFont">{{ $t('exPand.TotalRewards') }}</span>
          <div class="buttomBox">
            <span class="leftFont">{{
              formatNumber(grant_2.grant_day_all)
            }}</span>
            <span class="rightFont">{{ $t('exPand.Days') }}</span>
          </div>
        </div>
      </div>
      <div class="lineFont2">{{ $t('exPand.ActivationAmount') }}：</div>
      <div class="rewardBox">
        <div class="reward">
          <div class="twoTitle">
            <span class="topFont">{{ $t('exPand.PendingRewards') }}</span>
            <el-tooltip
              popper-class="markReferral markReferralOne"
              effect="dark"
              placement="bottom"
            >
              <div slot="content">
                <div>
                  {{ $t('exPand.exTextFiftySix') }}
                </div>
                <!-- <div>{{ $t('exPand.exTextNineteen') }}</div>
                <div>{{ $t('exPand.exTextTwenty') }}</div> -->
              </div>
              <img
                class="markImg"
                :src="$utils.getPng('referral-three')"
                alt=""
              />
            </el-tooltip>
          </div>
          <div class="buttomBox">
            <span class="leftFont">{{
              formatNumber(grant_2.grant_amount_pendding)
            }}</span>
            <span class="rightFont">{{ $t('exPand.money') }}</span>
          </div>
        </div>
        <div class="reward marLeft">
          <span class="topFont">{{ $t('exPand.ReceivedRewards') }}</span>
          <div class="buttomBox">
            <span class="leftFont">{{
              formatNumber(grant_2.grant_amount_processed)
            }}</span>
            <span class="rightFont">{{ $t('exPand.money') }}</span>
          </div>
        </div>
        <div class="reward marLeft">
          <span class="topFont">{{ $t('exPand.TotalRewards') }}</span>
          <div class="buttomBox">
            <span class="leftFont">{{
              formatNumber(grant_2.grant_amount_all)
            }}</span>
            <span class="rightFont">{{ $t('exPand.money') }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 奖励三 -->
    <div class="threeBox">
      <div class="titleBox">
        <span class="leftF">{{ $t('exPand.exTextTwelve') }}</span>
        <span class="rightF" @click="openRecord(2)">{{
          $t('exPand.EarningsRecords')
        }}</span>
      </div>
      <div class="rewardBox">
        <div class="reward rewardThree">
          <span class="topFont">{{ $t('exPand.TodayEarnings') }}</span>
          <div class="buttomBox">
            <span class="leftFont">{{
              formatNumber(grant_3.today_coupon)
            }}</span>
            <span class="rightFont">{{ $t('exPand.money') }}</span>
          </div>
          <div class="buttomFont">{{ grant_3.label }}</div>
        </div>
        <div class="reward marLeft">
          <span class="topFont">{{ $t('exPand.YesterdayEarnings') }}</span>
          <div class="buttomBox">
            <span class="leftFont">{{
              formatNumber(grant_3.yesterday_coupon)
            }}</span>
            <span class="rightFont">{{ $t('exPand.money') }}</span>
          </div>
        </div>
        <div class="reward marLeft">
          <span class="topFont">{{ $t('exPand.TotalEarnings') }}</span>
          <div class="buttomBox">
            <span class="leftFont">{{ formatNumber(grant_3.all_coupon) }}</span>
            <span class="rightFont">{{ $t('exPand.money') }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 规则说明 -->
    <div class="fourBox">
      <div class="bigTitle">{{ $t('exPand.Rules') }}</div>
      <!-- 奖励规则 -->
      <div class="contentOne">
        <div class="smallTitle">{{ ruleList.rule_1_title }}</div>
        <div class="one" v-for="(item,index) in ruleList.rule_1" :key="index">
          <span class="three">{{index + 1 }}.&nbsp;</span>
          <span class="rightC">
            <span class="three">{{ item.bold_text }}</span>
            {{ item.text.replace(item.bold_text,'') }}
            <span class="two" v-if="item.gray_font_text != ''">{{ item.gray_font_text }}</span></span>
        </div>
      </div>
      <!-- 判定细则 -->
      <div class="contentOne">
        <div class="smallTitle">{{ ruleList.rule_2_title }}</div>
        <div v-for="(item,index) in ruleList.rule_2" :key="index">
          <div class="one three">
            {{ item.title }}
          </div>
          <div class="one" v-for="(itm,idx) in item.child" :key="idx">
              &nbsp;&nbsp;&nbsp;&nbsp;{{ itm.i }}.&nbsp;<span class="rightC">{{ itm.v }}</span>
          </div>
        </div>
      </div>
      <!-- 其他说明 -->
      <div class="contentOne" style="margin-bottom: 0">
        <div class="smallTitle">{{ ruleList.rule_3_title }}</div>
        <div class="one" v-for="(item,index) in ruleList.rule_3" :key="index">{{ item }}</div>
      </div>
    </div>
    <!-- 邀请记录/收益记录弹出 -->
    <ReferralRecord
      :isType="isType"
      :isShow="isShow"
      :tableHeader="tableHeader"
      @confirm="isShow = false"
      @handleClose="isShow = false"
    />
    <!-- 切换奖励方式弹窗 -->
    <changeDia
      :isShow="isChange"
      :title="title"
      @handleClose="isChange = false"
      @confirm="changeCon"
    />
  </div>
</template>
<script>
import { exPandIndexAPI, exPandCheckAPI,getRule } from '@/utils/apiList/exPand'
import ReferralRecord from '@/components/ReferralRecord/index.vue'
import changeDia from '@/components/ReferralRecord/changeDia.vue'
export default {
  components: {
    ReferralRecord,
    changeDia,
  },
  data() {
    return {
      isShow: false,
      isChange: false,
      title: '',
      isInside: 0, //当前奖励方式 0-会员时长 1-开通金额奖励
      isType: 1,
      tableHeader: [],
      icon1: '',
      icon2: '',
      lang: '',
      invited: {},
      grant_1: {},
      grant_2: {},
      grant_3: {},
      ruleList:{},
    }
  },
  watch: {
    lang() {
      if (this.lang == 'en') {
        this.icon1 = 'referral-one1-en'
        this.icon2 = 'referral-two-en'
      } else if (this.lang == 'zhhk') {
        this.icon1 = 'referral-one1-hk'
        this.icon2 = 'referral-two-hk'
      } else {
        this.icon1 = 'referral-one1'
        this.icon2 = 'referral-two'
      }
    },
  },
  mounted() {
    this.lang = localStorage.getItem('lang') ?? 'zh'
    this.getInfo()
    this.getRuleList()
  },
  methods: {
    async getInfo() {
      try {
        let res = await exPandIndexAPI()
        if (res.status == 1) {
          this.invited = res.data.invited
          this.grant_1 = res.data.grant_1
          this.grant_2 = res.data.grant_2
          this.isInside = this.grant_2.grant_type //当前奖励方式 0-会员时长 1-开通金额奖励
          this.grant_3 = res.data.grant_3
        }
      } catch (error) {}
    },
    //获取奖励规则
    getRuleList(){
      getRule().then(res =>{
        this.ruleList = res.data
      }).catch(err => {})
    },
    formatNumber(value) {
      if (value == null) {
        return 0
      }
      let numericValue = Number(value)
      return numericValue.toLocaleString()
    },
    openRecord(row) {
      this.isType = row
      if (row === 1) {
        this.tableHeader = [
          '用户昵称',
          '邀请方式',
          '邀请时间',
          '状态',
          '邀请奖励',
        ]
      } else {
        this.tableHeader = ['用户昵称', '返利金额(元)', '邀请时间']
      }
      this.isShow = true
    },
    //立即前往
    toDrive() {
      window.open(`${this.$glb.fmpUrl}/files`, '_blank')
    },
    changeType(row) {
      if (this.isInside == row) {
        return
      }
      if (row == 0) {
        this.title = '会员时长奖励'
      } else {
        this.title = '开通金额奖励'
      }
      this.isChange = true
    },
    changeCon(row) {
      exPandCheckAPI({
        grant_type: row,
      })
        .then(res => {
          if (res.status == 1) {
            this.isInside = row
            this.isChange = false
          }
        })
        .catch(err => {})
    },
    //生成支付二维码
    copyBtn(url) {
      this.$copyText(url).then(
        e => {
          this.$toast('已复制邀请链接到剪贴板', 1)
        },
        function (e) {
          this.$toast('复制失败', 2)
        }
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.referralBox {
  padding-bottom: 20px;
  .oneBox {
    padding: 32px 24px;
    background: #ffffff;
    border-radius: 16px;
    margin-bottom: 24px;
    .titleBox {
      display: flex;
      flex-direction: column;
      .title {
        font-weight: 600;
        font-size: 18px;
        color: #2c2c2c;
        line-height: 26px;
        margin-bottom: 4px;
      }
      .content {
        font-weight: 400;
        font-size: 12px;
        color: #8a8b92;
        line-height: 20px;
      }
    }
    .imgBox {
      padding-left: 30px;
      margin-top: 24px;
      .bgImg {
        width: 836px;
        object-fit: cover;
      }
      .bgImgEn {
        width: 868px !important;
        object-fit: cover;
      }
    }
  }
  .twoBox {
    padding: 32px 24px;
    background: #ffffff;
    border-radius: 16px;
    margin-bottom: 24px;
    .titleBox {
      display: flex;
      flex-direction: column;
      margin-bottom: 24px;
      .title {
        font-weight: 600;
        font-size: 18px;
        color: #2c2c2c;
        line-height: 26px;
        margin-bottom: 4px;
      }
      .content {
        font-weight: 400;
        font-size: 12px;
        color: #8a8b92;
        line-height: 20px;
      }
    }
    .contentBox {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 24px;
      .top {
        font-weight: 500;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 22px;
        margin-bottom: 12px;
      }
      .bottom {
        display: flex;
        align-items: center;
        white-space: nowrap;
        flex-shrink: 0;
        .left {
          padding: 13px 20px;
          background: #f9f9f9;
          border-radius: 12px;
          width: 690px;
          overflow: hidden;
          .font {
            font-weight: 400;
            font-size: 14px;
            color: #8a8b92;
            line-height: 22px;
            width: 650px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .copyBtn {
          width: 210px;
          height: 48px;
          background: #7e72f6;
          border-radius: 24px;
          font-weight: 500;
          font-size: 16px;
          color: #ffffff;
          line-height: 24px;
          text-align: center;
          margin-left: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        .copyBtn:hover {
          background: #a39bf6;
          border-color: #a39bf6;
        }
        .copyBtn:active {
          background: #3213d8;
          border-color: #3213d8;
        }
      }
    }
    .bgImgTwo {
      width: 100%;
      height: 140px;
      object-fit: cover;
      cursor: pointer;
    }
  }
  .threeBox {
    padding: 32px 24px;
    background: #ffffff;
    border-radius: 16px;
    margin-bottom: 24px;
    .titleBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      .leftF {
        font-weight: 600;
        font-size: 18px;
        color: #2c2c2c;
        line-height: 26px;
      }
      .rightF {
        font-weight: 500;
        font-size: 14px;
        color: #7e72f6;
        line-height: 22px;
        cursor: pointer;
      }
      .rightB {
        display: flex;
        align-items: center;
        .front {
          font-weight: 400;
          font-size: 12px;
          color: #2c2c2c;
          line-height: 20px;
        }
        .behind {
          background: #f6f6f6;
          border-radius: 6px;
          padding: 3px;
          margin-left: 12px;
          display: flex;
          align-items: center;
          .inside {
            cursor: pointer;
            padding: 4px 12px;
            height: 26px;
            font-weight: 400;
            font-size: 13px;
            color: rgba(44, 44, 44, 0.8);
            line-height: 18px;
            background: transparent;
            border-radius: 5px;
            &:hover {
              color: #2c2c2c;
            }
          }
          .insideA {
            background: #7e72f6;
            font-weight: 500 !important;
            color: #ffffff !important;
          }
        }
      }
    }
    .lineFont {
      font-weight: 500;
      font-size: 14px;
      color: #2c2c2c;
      line-height: 22px;
      margin-bottom: 12px;
    }
    .lineFont2 {
      font-weight: 500;
      font-size: 14px;
      color: #2c2c2c;
      line-height: 22px;
      margin-top: 20px;
      margin-bottom: 12px;
    }
    .rewardBox {
      display: flex;
      justify-content: center;
      white-space: nowrap;
      .reward {
        width: 298px;
        display: flex;
        flex-direction: column;
        padding: 24px;
        background: #f9f9f9;
        border-radius: 12px;
        .topFont {
          font-weight: 500;
          font-size: 14px;
          color: #2c2c2c;
          line-height: 22px;
        }
        .buttomBox {
          display: flex;
          align-items: flex-end;
          .leftFont {
            font-weight: 600;
            font-size: 32px;
            color: #2c2c2c;
            line-height: 40px;
            // width: 225px;

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .rightFont {
            font-weight: 500;
            font-size: 16px;
            color: #2c2c2c;
            line-height: 24px;
            margin-bottom: 4px;
            margin-left: 4px;
          }
        }
        .buttomFont {
          font-weight: 400;
          font-size: 12px;
          color: #8a8b92;
          line-height: 20px;
          margin-top: 12px;
        }
        .markImg {
          width: 16px;
          height: 16px;
          object-fit: cover;
          margin-left: 4px;
          cursor: pointer;
        }
        .twoTitle {
          display: flex;
          align-items: center;
        }
      }
      .rewardThree {
        padding-bottom: 20px !important;
      }
      .marLeft {
        margin-left: 19px;
      }
    }
  }
  .fourBox {
    padding: 32px 24px;
    background: #ffffff;
    border-radius: 16px;
    .bigTitle {
      font-weight: 600;
      font-size: 18px;
      color: #2c2c2c;
      line-height: 26px;
      margin-bottom: 12px;
    }
    .contentOne {
      display: flex;
      margin-bottom: 24px;
      flex-direction: column;
      align-items: flex-start;
      .smallTitle {
        font-weight: 600;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 22px;
        margin-bottom: 5px;
      }
      .one {
        font-size: 12px;
        color: #2c2c2c;
        line-height: 26px;
        display: flex;
        align-items: flex-start;
        // letter-spacing: 1px;
        .rightC {
          text-align: left;
        }
      }
      .two {
        color: #8a8b92 !important;
      }
      .three {
        font-weight: 600;
      }
    }
  }
}
</style>
<style lang="scss">
.markReferral {
  border-radius: 8px !important;
  div {
    line-height: 20px;
  }
}
.markReferralOne {
  width: 320px;
}
</style>
